export const GET_REGISTER_REQUEST = "GET_REGISTER_REQUEST";
export const GET_REGISTER_SUCCESS = "GET_REGISTER_SUCCESS";
export const GET_REGISTER_ERROR = "GET_REGISTER_ERROR";

//Gernal 
export const OPEN_INVEST_MODAL = "OPEN_INVEST_MODAL";